module.exports = "../dist/frontend/icons/ui/chatUs.svg?54d3ffac5b605b2050e202de9edef187";